import api from '@/services/api';
import { make } from 'vuex-pathify';

const state = {};

const mutations = {
  ...make.mutations(state),
};

const actions = {
  /** FUNCTIONS */
  async getFunctions() {
    const r = await api.get('v2/datasources-trigger/functions');
    return r.data.data;
  },
  async createFunction(store, payload) {
    const r = await api.post('v2/datasources-trigger/functions', payload);
    return r.data.data;
  },
  async editFunction(store, data) {
    const { id, payload } = data;
    await api.put(`v2/datasources-trigger/functions/${id}`, payload);
  },
  async deleteFunction(store, id) {
    await api.delete(`v2/datasources-trigger/functions/${id}`);
  },

  /** TRIGGERS */
  async getTriggers(store, datasource) {
    const r = await api.get(`v2/datasources-trigger/${datasource}`);
    return r.data.data;
  },
  async createTrigger(store, data) {
    const { datasource, payload } = data;
    await api.post(`v2/datasources-trigger/${datasource}`, payload);
  },
  async editTrigger(store, data) {
    const { datasource, id, payload } = data;
    await api.put(`v2/datasources-trigger/${datasource}/${id}`, payload);
  },
  async deleteTrigger(store, data) {
    const { datasource, id } = data;
    await api.delete(`v2/datasources-trigger/${datasource}/${id}`);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
